import { setCookie } from "utils/cookie";
import { useState } from "react";
import { getCdn } from "utils";
import Image from "components/shared/Image";

const mainClass = `syndicated-message-center__message`;
const iconsPath = `${getCdn()}/logos/message-center/`;
const daysOfOneYear = 365;

const Message = ({
	closeMessageHandler,
	closeText,
	data: { type, title, dismissible, content, id, expiration = daysOfOneYear },
}) => {
	const [display, setDisplay] = useState(true);

	const getIconUrl = (icon) => {
		if (["crisis", "capacity"].includes(icon)) {
			icon = "purple-alert";
		} else if (icon === "health_advisory") {
			icon = "yellow-alert";
		}

		return `${iconsPath}${icon}.svg`;
	};

	const toggleDisplay = () => {
		setCookie(id, true, expiration);
		setDisplay(false);
		closeMessageHandler(id);
	};

	return (
		display && (
			<div className={mainClass}>
				<div
					className={`${mainClass}__icon ${mainClass}__icon--${type}`}
					aria-hidden="true"
				>
					<Image
						image={{ url: getIconUrl(type), title: type, loading: "eager" }}
					/>
				</div>
				<div className={`${mainClass}__data`}>
					<div className={`${mainClass}__data__title`}>{title}</div>
					{content && (
						<div
							className={`${mainClass}__data__content`}
							dangerouslySetInnerHTML={{ __html: content }}
						></div>
					)}
				</div>
				{dismissible && (
					<div
						className={`${mainClass}__close`}
						aria-label={closeText}
						tabIndex="0"
						onClick={toggleDisplay}
						style={{
							backgroundImage: `url(${iconsPath}close.svg)`,
						}}
					>
						x
					</div>
				)}
			</div>
		)
	);
};

export default Message;
